import BaseService from "./BaseService";

export default class ProfileServices extends BaseService {
    public static getUserDetails(token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'user/getUserDetail', {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        });
    }

    public static getACtiveSubscriptions(token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/getActiveSubscription', {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        });
    }

    public static getAllUsers(postData: any, token: string) {
        let url = 'admin/users';
        if (postData['search']) {
            url += '/search';
        }
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)

        });
    }


    public static getAllRejectedUsers(postData: any, token: string) {
        let url = 'admin/getAllManualReviewUser';
        // if(postData['search']) {
        //     url += '/search';
        // }
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)

        });
    }



    public static getInvaliadtionList(postData: any, token: string) {
        let url = 'admin/getEligibleToInvalidateForm8821';

        return BaseService.sendRequest(process.env.REACT_APP_API_URL + url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)

        });
    }


    public static updateUserStatus(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/updateUserStatus', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static getReportDashboard(userId: string, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + `admin/getReportDashboard?userId=${userId}`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
        });
    }

    public static updateInvalidateStatus(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/invalidateForms', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static createNewSubscriptionProduct(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'subscription/price', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static downloadTranscript(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/downloadTranscript', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }
    public static getAllSubscriptionsList(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/getAllSubscriptionUser', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static refundSubscriptionAmount(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/refundUserSubscription', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }


    public static getUserProgress(postData: any, token: string, selectedAccount: string) {
        let url = 'admin/getUserProgress?account=' + selectedAccount;
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)

        });
    }


    public static sendCustomEmail(postData: any, token: string) {
        let url = 'admin/sendCustomEmail';
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)

        });
    }

    public static downloadForm843(postData: any, token: string) {
        let url = 'admin/sendCustomEmail';
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)

        });
    }

    public static getAllLoanRejectedUser(postData: any, token: string) {
        let url = 'admin/getAllLoanRejectedUser';
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static downloadLoanRejectedFile(postData: any, token: string) {
        let url = 'admin/download/loanRejectedFile';
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static updateLoanRejectedFilesStatus(postData: any, token: string) {
        let url = 'admin/update/loanRejectedFilesStatus';
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static getEligiblePlansForUser(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/getEligiblePlansForUser', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

}